import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ReportsPage } from "./-components/ReportsPage";
import { SLUGS } from "./-components/reports";

const reportsSearchSchema = z.object({
  report: z.enum(SLUGS).optional(),
});

export const Route = createFileRoute("/(restricted)/rapporter/")({
  component: ReportsPage,
  validateSearch: reportsSearchSchema,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("analyse");

    const title = i18n.t("analyse:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});
